import { render, staticRenderFns } from "./UpdateJob.vue?vue&type=template&id=440fb4b8&"
import script from "./UpdateJob.vue?vue&type=script&lang=js&"
export * from "./UpdateJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports